export default "__VITE_PUBLIC_ASSET__eaa69c1e__"